/**
 * ROUTER DE AUTENTICACIÓN
 * 
 * Rutas simples sin guards.
 * accounts NO valida acceso, solo autentica.
 */

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivacyPolicyPage from './legal/PrivacyPolicyPage';
import MasterTermsPage from './legal/MasterTermsPage';
import SignupPage from './Signup';
import LogoutPage from './Logout';
import ForgotPasswordPage from './ForgotPassword';
import ResetPasswordPage from './ResetPassword';
import ChangePasswordPage from './ChangePassword';
import AccountsAuthCallback from './AuthCallback';
import Landing from './Landing';
import ChoosePathPage from './ChoosePath';
import CreateWorkspacePage from './CreateWorkspace';
import JoinWorkspacePage from './JoinWorkspace';
import PasteCodePage from './PasteCode';
import PendingInvitesPage from './PendingInvites';
import SuspendedPage from './Suspended';

// Onboarding steps (A10-A12b)
import FiscalPage from './onboarding/Fiscal';
import TeamPage from './onboarding/Team';
import VerticalPage from './onboarding/Vertical';
import ModulesPage from './onboarding/Modules';
import CelularesBundlePage from './onboarding/CelularesBundle';
import { OnboardingProvider } from '../contexts/OnboardingContext';

/** Wrapper that provides onboarding context to all onboarding routes */
const OnboardingRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <OnboardingProvider>{children}</OnboardingProvider>
);

const AuthRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/auth/callback" element={<AccountsAuthCallback />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/logout" element={<LogoutPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/change-password" element={<ChangePasswordPage />} />
      <Route path="/choose-path" element={<ChoosePathPage />} />
      <Route path="/create-workspace" element={<CreateWorkspacePage />} />
      <Route path="/join-workspace" element={<JoinWorkspacePage />} />
      <Route path="/paste-code" element={<PasteCodePage />} />
      <Route path="/pending-invites" element={<PendingInvitesPage />} />
      <Route path="/suspended" element={<SuspendedPage />} />

      {/* Onboarding wizard — 4-step flow after workspace creation (A05) */}
      <Route path="/onboarding/fiscal" element={<OnboardingRoute><FiscalPage /></OnboardingRoute>} />
      <Route path="/onboarding/equipo" element={<OnboardingRoute><TeamPage /></OnboardingRoute>} />
      <Route path="/onboarding/negocio" element={<OnboardingRoute><VerticalPage /></OnboardingRoute>} />
      <Route path="/onboarding/modulos" element={<OnboardingRoute><ModulesPage /></OnboardingRoute>} />
      <Route path="/onboarding/celulares-bundle" element={<OnboardingRoute><CelularesBundlePage /></OnboardingRoute>} />

      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/terms" element={<MasterTermsPage />} />
      <Route path="/" element={<Landing />} />
    </Routes>
  );
};

export default AuthRouter;
